import React from 'react';
import classNames from 'classnames';

import './divider.scss';

type DividerProps = React.HTMLAttributes<HTMLDivElement> & {
  orientation: 'vertical' | 'horizontal';
};

export function Divider(props: DividerProps): JSX.Element {
  const { className, orientation, ...divProps } = props;
  return <div className={classNames('divider', className, orientation)} {...divProps}></div>;
}
